import { type USState } from '@strata/constants';
import { formatNameLastFirst, formatPhoneNumber } from '@strata/helper-functions';
import { InfoDialog } from '@strata/react-dialog';
import { FormSectionRow } from '@strata/react-form-section';
import { MailToHyperlink } from '@strata/react-hyperlink';
import { AddressDetailLabelValue, DetailLabelValuePair } from '@strata/react-label-value-pairs';
import { type ComponentProps } from 'react';

interface ContactInfoDialogProps {
    isOpen: boolean;
    onClose: ComponentProps<typeof InfoDialog>['onClose'];
    memberDetails?: {
        firstName?: string;
        lastName?: string;
        phone?: string;
        email?: string;
        memberAddress1?: string;
        memberAddress2?: string;
        memberCity?: string;
        memberState?: USState;
        memberZip?: string;
    };
}

export const ContactInfoDialog = ({
    isOpen,
    onClose,
    memberDetails = undefined,
}: ContactInfoDialogProps) => (
    <InfoDialog
        dialogTitle="Contact Information"
        isOpen={isOpen}
        onClose={onClose}
        dialogContent={
            <>
                <FormSectionRow
                    rowContent={
                        <DetailLabelValuePair
                            label="Patient Name"
                            value={formatNameLastFirst(
                                memberDetails?.lastName,
                                memberDetails?.firstName,
                            )}
                        />
                    }
                />
                <FormSectionRow
                    rowContent={
                        <>
                            <DetailLabelValuePair
                                style={{ width: '50%' }}
                                label="Phone"
                                value={formatPhoneNumber(memberDetails?.phone)}
                            />
                            <DetailLabelValuePair
                                style={{ width: '50%' }}
                                label="Email"
                                value={<MailToHyperlink emailAddress={memberDetails?.email} />}
                            />
                        </>
                    }
                />
                <FormSectionRow
                    rowContent={
                        <AddressDetailLabelValue
                            label="Address"
                            address1={memberDetails?.memberAddress1}
                            address2={memberDetails?.memberAddress2}
                            city={memberDetails?.memberCity}
                            state={memberDetails?.memberState}
                            zip={memberDetails?.memberZip}
                        />
                    }
                />
            </>
        }
    />
);
